<template>
  <div class="row mb-2 mb-xl-3">
    <div class="col-auto d-block">
      <h4 class="text-dark">Empresas</h4>
    </div>

    <div class="col-auto ml-auto text-right mt-n1">
      <button type="button" class="btn btn-primary" @click="showCreate">
        <i class="bi bi-plus"></i> Crear
      </button>
    </div>
  </div>

  <table id="businessTable" class="table table-sm table-striped bg-white" style="width:100%">
    <thead class="thead-dark">
      <tr>
        <th class="font-weight-normal">Id</th>
        <th class="font-weight-normal">Nombre</th>
        <th class="font-weight-normal">Organización Id</th>
        <th class="actions"></th>
      </tr>
    </thead>
  </table>

  <modal-form
    :form="businessSelected"
    @store="loadList"
  ></modal-form>

  <delete-confirmation
    :form="businessSelected"
    @deleted="loadList"
  ></delete-confirmation>

  <toast :config="alert"></toast>
</template>

<script>
// @ is an alias to /src
import DeleteConfirmation from '@/components/Business/DeleteConfirmation';
import ModalForm from '@/components/Business/ModalForm';
import { onMounted, reactive, ref, nextTick } from 'vue';
import CONSTANS from '@/util/constants';
import actions from '@/util/actions';
import $ from 'jquery';

export default {
  components: {
    'modal-form': ModalForm,
    'delete-confirmation': DeleteConfirmation,
  },

  setup() {
    const alert = reactive({
      message: "",
      title: "",
    })
    const businessSelected = ref({})
    const businessTable = ref(null)

    onMounted(() => {
      initTable();
    })

    function initTable() {
      nextTick(() => {
        $.fn.dataTable.ext.errMode = 'none';

        businessTable.value = $('#businessTable').DataTable({
          ajax:  {
            url: `${CONSTANS.API_URL}/empresas`,
            dataSrc: 'result',
            beforeSend: function (request) {
              request.setRequestHeader("Authorization", `Bearer ${localStorage.token}`);
            },
            error: function(request) {
              if (request.status == 401) {
                actions.logout();
              }

              alert.title = "Error al buscar";
              alert.message = request.response ? request.response.data.msg : 'Error en la petición';
              $('#toast').toast('show');
            },
          },
          columns: [
            { className: 'font-weight-light', data: "ID" },
            { className: 'font-weight-light', data: "Nombre" },
            { className: 'font-weight-light', data: "OracleID" },
            null,
          ],
          columnDefs: [{
            targets: -1,
            data: null,
            defaultContent: `<button type="button" class="btn btn-info d-inline-block edit">
            <i class="bi bi-pencil-square"></i>
            </button>
            <button type="button" class="btn btn-danger d-inline-block ml-2 delete">
              <i class="bi bi-x"></i>
            </button>`
          }, {
            className: "text-right", targets: 3
          }],
          ordering: false,
          searching: true,
          info: false,
          language: {
            emptyTable: 'Sin empresas',
            zeroRecords: "No se encontraron resultados",
            infoEmpty: "No se encontraron resultados",
            search: "Buscar:",
            lengthMenu: "Mostrar _MENU_ entradas",
            paginate: {
              next: "Siguiente",
              previous: "Previo",
            }
          },
        });

        $('#businessTable tbody').on('click', 'button.edit', function () {
          showEdit(businessTable.value.row($(this).parents('tr')).data());
        });

        $('#businessTable tbody').on('click', 'button.delete', function () {
          showDelete(businessTable.value.row($(this).parents('tr')).data());
        });
      });
    }

    function loadList() {
      businessTable.value.ajax.reload();
    }

    function showCreate() {
      businessSelected.value = {};
      $('#businessFormModal').modal('show');
    }

    function showEdit(business) {
      businessSelected.value = business;
      $('#businessFormModal').modal('show');
    }

    function showDelete(business) {
      businessSelected.value = business;
      $('#businessDeleteModal').modal('show');
    }

    return {
      businessSelected,
      loadList,
      showCreate,
      showEdit,
      showDelete,
    }
  }
}
</script>

<style lang="scss">
th {
  &.actions {
    width: 14rem;
  }
}

#businessTable_length,
#businessTable_filter {
  .form-control {
    display: inline-block;
    width: auto;
  }
}

#businessTable_filter {
  float: right;

  .form-control {
    margin-left: 5px;
  }
}
</style>
